import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormArray, FormGroup, FormControl, Validators } from '@angular/forms';
import { BulkOrderFormService } from 'src/app/_services/bulk-order-form.service';
import { DialogService } from 'primeng/dynamicdialog';
import { UserService } from 'src/app/_services';
import { MessageService } from 'primeng/api';
import { AddOrderTypeComponent } from '../add-order-type/add-order-type.component';

@Component({
  selector: 'app-create-order-type',
  templateUrl: './create-order-type.component.html',
  styleUrls: ['./create-order-type.component.scss']
})
export class CreateOrderTypeComponent implements OnInit {
  isLoading: boolean = true;

  constructor(
    private fb: FormBuilder,
    private bulkOrderFormService: BulkOrderFormService,
    private dialogService: DialogService,
    private userService: UserService,
    private messageService: MessageService
  ) { }

  order_types: any[] = []

  orderTypeColumns: any[] = [
    { field: 'type_name', header: 'Order Type' },
    { field: 'order_size', header: 'Size' },
    { field: 'is_biocross', header: 'Biocross?' }
  ]

  items: any[] = []


  ngOnInit(): void {
    this.bulkOrderFormService.getBulkOrderTypes().subscribe((res) => {
      this.order_types = res.body;
      console.log('order_types', this.order_types);
      
    
      this.order_types.forEach((item: any) => {
        item.is_biocross = item.is_biocross ? 'Yes' : 'No';
      });
    })

  }


  showOrderTypeDetailsDialog(order: any, event: any) {
    const ref = this.dialogService.open(CreateOrderTypeComponent, {
      header: 'Create Order Type',
      width: '70%',
      data: order,
    });

    ref.onClose.subscribe((result: any) => {
      if (result) {
        this.bulkOrderFormService.getBulkOrderTypes().subscribe((res) => {
          this.order_types = res.body;
        })
      }
    });
  }

  storeRowDetail(row: any) {
    console.log('row', row);

  }

  getNumberofColumns() {
    return this.orderTypeColumns.length + 1;
  }

  showOrderTypeDialog() {
    const ref = this.dialogService.open(AddOrderTypeComponent, {
      header: 'Create Order Type',
      width: '70%',
      data: {},
    });

    ref.onClose.subscribe((result: any) => {
      if (result) {
        this.bulkOrderFormService.getBulkOrderTypes().subscribe((res) => {
          this.order_types = res.body;
        })
      }
    });
  }

}
